<script>
import Content from '@/components/templates/ContentV2.vue'
import "@/assets/scss/navbar.scss";
import * as role from "@/views/ms/SdiRole";
import VueFeather from 'vue-feather';
export default {
  components: {
      Content,VueFeather
    },
  data() {
    return {
      current_role: null,
      roles:[],
      user:null,
    }
  },
  provide() {
    const appData = {}
    Object.defineProperty(appData, "current_role", {
        enumerable: true,
        get: () => this.current_role,
    })

    return {
        appData,
    }
  },
  computed:{
    isLogin(){
      return this.$store.getters['auth/isAuthenticated'] && this.user ? true : false
    },
    isSuperAdmin(){
      return this.current_role ? role.isSuperAdmin([this.current_role]) : false;
    },
    isPembinaData(){
      return this.current_role ? role.isPembinaData([this.current_role]) : false;
    },
    isWalidata(){
      return this.current_role ? role.isWalidata([this.current_role])  : false;
    },
    isProdusenData(){
      return this.current_role ? role.isProdusenData([this.current_role]) : false;
    },
    canAccessUserSetting(){
      return role.isSuperAdmin(this.roles);
    },
    canAccessSdiOrganizationSetting(){
      return role.isSuperAdmin(this.roles) || role.isPembinaData(this.roles) || role.isWalidata(this.roles);
    },
    canAccessMutasiProdusen(){
      const roles = this.roles || [];
      const user = this.user || {};
      const isSuperAdmin =
        role.isSuperAdmin(roles) ||
        roles.includes('ROLE_SUPERADMIN') ||
        roles.includes('ROLE_ADMIN');
      const isPembinaPusat =
        role.isPembinaDataPusat(roles) ||
        roles.includes('ROLE_PEMBINA_DATA_PUSAT');
      const isSpecialUser =
        user.email === 'brian.firdian@gmail.com' ||
        user.email === 'brianf@bps.go.id';
      return isSuperAdmin || isPembinaPusat || isSpecialUser;
    },
  },
  mounted(){
    const rawRole = this.$store.getters['auth/user']?.role;
    if (Array.isArray(rawRole)) {
      this.roles = [...rawRole].sort();
    } else if (typeof rawRole === 'string') {
      const trimmed = rawRole.trim();
      const stripped = trimmed.startsWith('[') && trimmed.endsWith(']') ? trimmed.slice(1, -1) : trimmed;
      this.roles = stripped.split(',').map(s => s.trim()).filter(Boolean).sort();
    } else {
      this.roles = [];
    }
    this.user = this.$store.getters['auth/user'] || {};
    this.current_role = localStorage.getItem('msCurrentRole') === null ? (this.roles[0] || '') : localStorage.getItem('msCurrentRole');
  },
  methods:{
    roleFormatter(role){
      if(!role) return '-';
      role = role.replace('ROLE_','');
      return role.replaceAll('_',' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    },
    avatarNameFormatter(name){
      if(!name) return '-'
      let split = name.split(/[\s.,]/)[0].split(" ");
      return split[0].charAt(0);
    },
    changeRole(role){
      this.current_role = role;
      this.goToAccessesiblePage();
      localStorage.setItem('msCurrentRole', this.current_role);
    },
    goToAccessesiblePage(){
      let path = this.$route.path;
      if(path == '/metadata/usulan-metadata' || path == '/metadata/summary'){
        if(!this.isWalidata && !this.isProdusenData && !this.isPembinaData && !this.isSuperAdmin){
          this.$router.push('/metadata');
        }
      }
      if(path == '/metadata/pemeriksaan'){
        if(!this.isPembinaData && !this.isSuperAdmin){
          this.$router.push('/metadata');
        }
      }
    }

  }
}
</script>
<template>
  <div>
   <div id="navbar-metadata" class="navbar-project">
      <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-brand href="#">MS</b-navbar-brand>
        <b-navbar-toggle target="nav-collapse">
          <template #default="{ expanded }">
              <b-icon v-if="expanded" icon="x"></b-icon>
              <b-icon v-else icon="list"></b-icon>
            </template>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav pills>
            <b-nav-item to="/">
              <VueFeather type="home" size="14"></VueFeather>
            </b-nav-item>
            <b-nav-item to="/metadata-dashboard" :active="$route.path == '/metadata-dashboard' ? true : false">
              <VueFeather type="pie-chart" size="14"></VueFeather>Dashboard
            </b-nav-item>
            <b-nav-item to="/metadata/usulan-metadata" :active="$route.path == '/metadata/usulan-metadata' ? true : false" v-if="isWalidata || isProdusenData">
              <VueFeather type="edit-3" size="14"></VueFeather>Entri Pelaporan</b-nav-item>
            <b-nav-item to="/metadata/summary" :active="$route.path == '/metadata/summary' ? true : false" v-if="isWalidata || isProdusenData">
             <VueFeather type="list" size="14"></VueFeather>Daftar Pelaporan</b-nav-item>
            <b-nav-item to="/metadata/pemeriksaan" :active="$route.path == '/metadata/pemeriksaan' ? true : false" v-if="isPembinaData">
              <VueFeather type="check-circle" size="14"></VueFeather>Pemeriksaan
            </b-nav-item>
            <b-nav-item to="/metadata/report" :active="$route.path == '/metadata/report' ? true : false" v-if="isPembinaData">
              <VueFeather type="file-text" size="14"></VueFeather>Report
            </b-nav-item>
            <b-nav-item to="/metadata/pengaturan/mutasi-produsen-kegiatan" :active="$route.path == '/metadata/pengaturan/mutasi-produsen-kegiatan' ? true : false" v-if="canAccessMutasiProdusen">
              <VueFeather type="repeat" size="14"></VueFeather>Mutasi Produsen
            </b-nav-item>
            <b-nav-item to="/metadata/pengaturan/recycle-kegiatan" :active="$route.path == '/metadata/pengaturan/recycle-kegiatan' ? true : false" v-if="canAccessMutasiProdusen">
              <VueFeather type="refresh-cw" size="14"></VueFeather>Recycle Kegiatan
            </b-nav-item>
            <b-nav-item to="/metadata/panduan" :active="$route.path == '/metadata/panduan' ? true : false">
              <VueFeather type="layout" size="14"></VueFeather>Panduan
            </b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav v-if="isLogin" class="ml-auto justify-content-end align-items-center">
            <div v-if="roles.length == 1" class="text-13  text-primary">
              {{roleFormatter(current_role)}}
            </div>
            <b-dropdown v-else right size="sm" variant="logout" toggle-class="d-flex align-items-center text-primary" >
              <template #button-content>{{roleFormatter(current_role)}}</template>
              <b-dropdown-item 
                v-for="(role , index) in roles" 
                :key="index" 
                :active="role == current_role"
                @click="changeRole(role)">
                <span class="mr-2">{{roleFormatter(role)}}</span>
                <b-icon icon="check-circle-fill" class="ml-auto" v-if="role == current_role"></b-icon>
              </b-dropdown-item>
            </b-dropdown>

            <b-dropdown no-caret right size="sm" toggle-class="ml-3 d-flex align-items-center text-primary" >
              <template #button-content>
                <div class="user-avatar">{{avatarNameFormatter(user.name)}}</div>
              </template>
              <b-dropdown-group header="User">
                <b-dropdown-item>{{user.name}} </b-dropdown-item>
                <b-dropdown-item v-if="user && user.sdiOrganization"> {{user.sdiOrganization.name}}</b-dropdown-item><b-dropdown-item v-else-if="user && user.organisasi"> {{user.organisasi}}</b-dropdown-item>
                <b-dropdown-item  to="/user/change-password" v-if="user && user.email && user.email.includes('@') && user.email.split('@')[1] != 'bps.go.id'">
                  <VueFeather type="shield" size="14"></VueFeather>&nbsp; Ubah Password
                </b-dropdown-item>
              </b-dropdown-group>
              
              <b-dropdown-group header="Pengaturan" v-if="canAccessUserSetting || canAccessSdiOrganizationSetting || canAccessMutasiProdusen">
                <b-dropdown-item to="/pengaturan/user" v-if="canAccessUserSetting">
                  <VueFeather type="users" size="14" ></VueFeather>&nbsp; User
                </b-dropdown-item>
                <b-dropdown-item to="/pengaturan/sdi/organization" v-if="canAccessSdiOrganizationSetting">
                  <VueFeather type="briefcase" size="14"></VueFeather>&nbsp; Organisasi SDI
                </b-dropdown-item>
                <b-dropdown-item to="/metadata/pengaturan/mutasi-produsen-kegiatan" v-if="canAccessMutasiProdusen">
                  <VueFeather type="repeat" size="14"></VueFeather>&nbsp; Mutasi Produsen
                </b-dropdown-item>
                <b-dropdown-item to="/metadata/pengaturan/recycle-kegiatan" v-if="canAccessMutasiProdusen">
                  <VueFeather type="refresh-cw" size="14"></VueFeather>&nbsp; Recycle Kegiatan
                </b-dropdown-item>
              </b-dropdown-group>
              
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item to="/logout"><VueFeather type="power" size="14"></VueFeather>&nbsp; Keluar</b-dropdown-item>
            </b-dropdown>
          </b-navbar-nav>

          <b-navbar-nav v-else class="ml-auto">
            <b-button
              variant="login"
              size="sm"
              type="submit"
              to="/login"
              class="btn-login"
              >Masuk</b-button
            >
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
   </div>
   <Content />
  </div>
</template>